import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { forwardRef, memo } from 'react';

import Box from 'shopper/components/Box';
import Flex from 'shopper/components/Flex';
import Text from 'shopper/components/Text';

import GooglePublisherTagAdSlot from 'components/AdSlots/GooglePublisherTagAdSlot';

import HEADING from 'constants/heading';

const AD_WIDTH_IN_PX = 300;
const AD_HEIGHT_IN_PX = 250;

const SidebarGoogleAd = forwardRef(
  (
    {
      adId,
      adPath,
      adSizes,
      adResponsiveSizesMap,
      adProps,
      forwardedRef,
      showAdSlotOnBreakpoints,
      ...rest
    },
    ref
  ) => {
    const theme = useTheme();

    return (
      <Box
        ref={forwardedRef || ref}
        display={['none', null, null, null, 'block']}
        {...rest}
      >
        <Flex alignItems="center" flexDirection="column">
          <Text
            size="size3"
            color={theme.app.googleAd.foreground}
            py={4}
            px={6}
            display={['none', null, null, null, 'block']}
          >
            {HEADING.PAID_MEDIA}
          </Text>
          <GooglePublisherTagAdSlot
            adId={adId}
            adPath={adPath}
            adSizes={adSizes}
            adResponsiveSizesMap={adResponsiveSizesMap}
            height={AD_HEIGHT_IN_PX}
            showAdSlotOnBreakpoints={showAdSlotOnBreakpoints}
            width={AD_WIDTH_IN_PX}
            {...adProps}
          />
        </Flex>
      </Box>
    );
  }
);

SidebarGoogleAd.displayName = 'SidebarGoogleAd';

SidebarGoogleAd.defaultProps = {
  adSizes: [AD_WIDTH_IN_PX, AD_HEIGHT_IN_PX],
  adResponsiveSizesMap: [],
  forwardedRef: null,
  showAdSlotOnBreakpoints: [false, null, null, true],
};

SidebarGoogleAd.propTypes = {
  adId: PropTypes.string.isRequired,
  adPath: PropTypes.string.isRequired,
  adSizes: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      ),
    ])
  ),
  adResponsiveSizesMap: PropTypes.arrayOf(
    PropTypes.shape({
      viewport: PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.arrayOf(PropTypes.number),
        ])
      ).isRequired,
      sizesMap: PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.arrayOf(PropTypes.number),
        ])
      ).isRequired,
    })
  ),
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
  showAdSlotOnBreakpoints: PropTypes.arrayOf(PropTypes.bool),
};

export default memo(SidebarGoogleAd);
